import { render, staticRenderFns } from "./Routes.vue?vue&type=template&id=6457ad2a&"
import script from "./Routes.vue?vue&type=script&lang=js&"
export * from "./Routes.vue?vue&type=script&lang=js&"
import style0 from "./Routes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports